<div class="row config-container">
  <div class="col-2 signifyBookmd config-text">Configuration mode</div>
  <div class="col-4">
    <select id="multiconfig-Dropdown" [(ngModel)]="selectedConfig.ConfigurationMode" class="signifyBookmd select-dimming"
      (change)="onChangeList($event.target.value)">
      @for (config of allConfigs; track config) {
        <option [value]="config" class="info-val">
          {{ config }}
        </option>
      }
    </select>
  </div>
  <div class="col-6"></div>
</div>
